import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { map, Observable } from 'rxjs';
import { AuthService } from './auth.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard {
  constructor(private authService: AuthService, private router: Router) {}

  canActivate(): Observable<boolean> {
    return this.authService.user$.pipe(
      map((user) => {
        if (!this.authService.isUserLoggedIn(user)) {
          this.router.navigate(['login']);
          return false;
        } else if (this.authService.mustChangePassword(user)) {
          this.router.navigate(['change-password']);
          return false;
        }
        return true;
      })
    );
  }
}
